import type { DadataParams, SuggestionResponse } from '@/js/types/dadata.ts';
import { makeRequest } from '@/js/api/request-service.ts';

const URL = 'https://suggestions.dadata.ru/suggestions/api/4_1/rs/';
const TOKEN = '70d907b280ff48675ce856fbbb9a8a26050e467d';

function getHeaders() {
  return {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'Authorization': `Token ${TOKEN}`,
  };
}

const abortController = new AbortController();

export function abort(): void {
  abortController.abort();
}

export async function getAddressSuggests(
  query: string,
  params: DadataParams,
) {
  return makeRequest<SuggestionResponse>({
    url: `${URL}suggest/address`,
    method: 'POST',
    headers: getHeaders(),
    data: { query, ...params },
  });
}

export async function getGeocoding(lon: number, lat: number) {
  return makeRequest<SuggestionResponse>({
    url: `${URL}geolocate/address`,
    method: 'POST',
    headers: getHeaders(),
    data: { lat, lon },
  });
}
